import { render } from "./vue-navigation-bar.vue?vue&type=template&id=3a31a5e2"
import script from "./vue-navigation-bar.vue?vue&type=script&lang=js"
export * from "./vue-navigation-bar.vue?vue&type=script&lang=js"

import "./vue-navigation-bar.vue?vue&type=style&index=0&id=3a31a5e2&lang=scss"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__